export const billDraftingActions = {
  GET_TITLES: 'GET_TITLES',
  STORE_TITLES: 'STORE_TITLES',
  GET_TITLE_CONTENT: 'GET_TITLE_CONTENT',
  STORE_TITLE_CONTENT: 'STORE_TITLE_CONTENT',
  GET_TEXT_CONTENT: 'GET_TEXT_CONTENT',
  STORE_TEXT_CONTENT: 'STORE_TEXT_CONTENT',
  LOADING_CONTENT: 'LOADING_CONTENT',
};

// Action for triggering download when click on file icon
export const getTitles = () => {
  return { type: billDraftingActions.GET_TITLES };
};

// Action for detecting if the file has been downloaded successfully
export const storeTitles = titles => {
  return { type: billDraftingActions.STORE_TITLES, titles };
};

export const getTitleContent = title => {
  return { type: billDraftingActions.GET_TITLE_CONTENT, title };
};

export const storeTitleContent = titleContent => {
  return { type: billDraftingActions.STORE_TITLE_CONTENT, titleContent };
};

export const getTextContent = (textType, section) => {
  return { type: billDraftingActions.GET_TEXT_CONTENT, textType, section };
};

export const storeTextContent = text => {
  return { type: billDraftingActions.STORE_TEXT_CONTENT, text };
};

export const loadingContent = status => {
  return { type: billDraftingActions.LOADING_CONTENT, status };
};
